var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsPlatformIconXbox = function SvgNewcsPlatformIconXbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_platform_icon_xbox_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M870 572h18v18h-18z",
    "data-name": "\\u77E9\\u5F62 214",
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_platform_icon_xbox_svg__a)",
    transform: "translate(-870 -572)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "m875.1 575.2.133-.112A6.84 6.84 0 0 1 879 574a6.84 6.84 0 0 1 3.6.994 2.3 2.3 0 0 1 .392.322C881.975 574.2 879 576.59 879 576.59a9.5 9.5 0 0 0-2.688-1.54 1.43 1.43 0 0 0-1.19.14m9.016 1.057a1 1 0 0 1-.1-.105 1 1 0 0 0-.84-.329 8 8 0 0 0-2.94 1.9 20 20 0 0 1 2.674 3.255c1.015 1.645 1.617 2.94 1.246 4.739A7.04 7.04 0 0 0 886 581a6.95 6.95 0 0 0-1.862-4.753m-2.527 5.425a55 55 0 0 0-2.009-2.107c-.189-.189-.392-.385-.6-.6 0 0-.329.322-.749.749-.539.539-1.232 1.246-1.624 1.659-.686.735-2.66 3.045-2.772 4.34 0 0-.455-1.022.525-3.4a18 18 0 0 1 3.318-4.613 8.4 8.4 0 0 0-1.626-1.355l-.035-.021a3.2 3.2 0 0 0-1.379-.49 1.2 1.2 0 0 0-.763.378 7 7 0 1 0 10.283 9.5 6 6 0 0 0-1.092-2.262c-.217-.3-1.029-1.267-1.477-1.778",
    "data-name": "\\u8DEF\\u5F84 480"
  }))));
};
export default SvgNewcsPlatformIconXbox;